import { Inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { UnespCoreEnvironment } from 'src/libs/unesp-core'
import { identity, Observable } from 'rxjs'
import { ErrorHandlerService } from './error-handler.service'

@Injectable({
  providedIn: 'root',
})
export class ReporteIdentificacaoService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  reportar(inscricaoDocumentoId: number, justificativa?: string): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}/reporte-identificacao`, { inscricaoDocumentoId, justificativa })
      .pipe(identity, this.errorHandlerService.catchError())
  }

  listarPendentes(concursoId: number): Observable<any[]> {
    return this.http
      .get<any[]>(`${this.baseUrl}/reporte-identificacao/pendentes/${concursoId}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  listarVisiveis(concursoId: number): Observable<any[]> {
    return this.http
      .get<any[]>(`${this.baseUrl}/reporte-identificacao/visiveis/${concursoId}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  confirmar(reporteId: number, justificativa: string): Observable<any> {
    return this.http
      .put<any>(`${this.baseUrl}/reporte-identificacao/${reporteId}/confirmar`, { justificativa })
      .pipe(identity, this.errorHandlerService.catchError())
  }

  descartar(reporteId: number, justificativa: string): Observable<any> {
    return this.http
      .put<any>(`${this.baseUrl}/reporte-identificacao/${reporteId}/descartar`, { justificativa })
      .pipe(identity, this.errorHandlerService.catchError())
  }

  verificarBloqueioEnvelope(concursoId: number): Observable<{ bloqueado: boolean }> {
    return this.http
      .get<{ bloqueado: boolean }>(`${this.baseUrl}/reporte-identificacao/bloqueio-envelope/${concursoId}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }
}
